import React from 'react';
import classNames from '../helpers/classNames.js';
import { useMinimalExecutionTime, defaultTime } from './hooks/useMinimalExecutionTime.js';
const ActivityIndicator = ({
  size = ActivityIndicator.sizes.MEDIUM,
  busy
}) => {
  const activityIndicatorSizeClass = classNames('ebds-a-activity-indicator', {
    [`--${size}`]: size
  });
  return /*#__PURE__*/React.createElement("div", {
    className: activityIndicatorSizeClass,
    role: "alert",
    "aria-busy": busy
  });
};
ActivityIndicator.sizes = {
  MEDIUM: 'medium',
  LARGE: 'large',
  SMALL: 'small'
};
ActivityIndicator.busyStates = {
  busy: 'true',
  notBusy: 'false'
};
export const ActivityIndicatorWithMinimumRendering = ({
  onFinished,
  finished = true,
  ...rest
}) => {
  const dontShowBefore = 300;
  const initialIdleCounter = useMinimalExecutionTime(dontShowBefore);
  const renderingTimer = useMinimalExecutionTime(dontShowBefore + defaultTime);
  if (initialIdleCounter.isInProgress) {
    if (finished) {
      onFinished();
    }
    return null;
  }
  if (renderingTimer.isInProgress || !finished) {
    return /*#__PURE__*/React.createElement(ActivityIndicator, rest);
  }
  onFinished();
  return null;
};
export default ActivityIndicator;